import styled from 'styled-components';

export const MemoryWrapper = styled.div`
  margin: 10px;
  display: flex;
  overflow-x: auto;
`;
